import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { StepperService } from "../../../services/stepper.service";
import { Router, ActivatedRoute } from "@angular/router";
import { AccountService } from "../../../services/account.service";
import { constants } from "../../../utils/constants";
import { IErrorAlert } from "src/app/interfaces/error.interface";
import helpers from "src/app/utils/helpers";

@Component({
  selector: "app-new-password",
  templateUrl: "./new-password.component.html",
  styleUrls: ["../../auth.styles.css"],
})
export class NewPasswordComponent implements OnInit {
  constants: any = constants;
  helpers: any = helpers;
  form: FormGroup;
  match: boolean = true;
  loading = false;
  error: IErrorAlert;
  route: string;

  constructor(
    private _fb: FormBuilder,
    private _router: Router,
    private _route: ActivatedRoute,
    public _account: AccountService,
    public _stepper: StepperService
  ) {
    this._route.data.subscribe((data: any) => {
      this._stepper.setCurrent(data.step);
      if (!this._account.getCompanyData().ruc) {
        this._router.navigate([`${data.operation}-password/enter-code`]);
      }
      if(data.operation === 'recover'){
         this.route = 'recover-password/success'
      }else{
         this.route = 'create-password/success'
      }
      
  
    });
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.form = this._fb.group({
      password: [
        "",
        [
          Validators.required,
          Validators.pattern(constants.validations.numeric.pattern),
          Validators.minLength(6),
          this.consecutiveDigits,
          this.hasRepeatingDigits,
        ],
      ],
      confirmPassword: [
        "",
        [
          Validators.required,
          Validators.pattern(constants.validations.numeric.pattern),
          Validators.minLength(6),
          this.consecutiveDigits,
          this.hasRepeatingDigits,
        ],
      ],
    });
    this.helpers.initFormListeners(this.form);

    this.form.valueChanges.subscribe((values) => {
      if (
        this.form.get("password").valid &&
        this.form.get("confirmPassword").valid
      ) {
        this.match = values.password === values.confirmPassword;
      } else {
        this.match = true;
      }
    });
  }

  

  continue() {
    this.error = null;
    this.loading = true;
    this._account.createPassword(this.form.get("password").value).subscribe(
      () => this._router.navigate([this.route]),
      (err: IErrorAlert) => {
        this.error = { ...err, width: "auto" };
        this.loading = false;
      }
    );
  }

  keyUp(e){
    this.error = null;
  }

  anyAlert() {
    return !this.match || this.error;
  }

  // Validations
  consecutiveDigits(control: FormControl): { [s: string]: boolean } {
    const password = control.value;
    let consecutiveDigits = false;
    if (password.length === 6 && password !== '050505') {
      let current = password[0];
      [...password].forEach((digit) => {
        if (digit == current) {
          consecutiveDigits = true;
        } else {
          consecutiveDigits = false;
        }
        if (current == 9) current = 0;
        else current++;
      });
    }
    return consecutiveDigits
      ? {
          consecutiveDigits,
        }
      : null;
  }

  hasRepeatingDigits(control: FormControl): { [s: string]: boolean } {
    let repeatingDigits = false;
    if (control.value.length === 6) {
      const password = control.value;
      [...password].forEach((digit) => {
        var finalSplit = password.toString().split(""),
          times = 0;
        for (let i = 0; i < finalSplit.length; i++) {
          if (finalSplit[i] == digit) {
            times++;
          } else {
            times = 0
          }
          if (times >= 4) {
            repeatingDigits = true;
          }
        }
      });
    }
    return repeatingDigits
      ? {
        repeatingDigits,
        }
      : null;
  }
}
